import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {TerminalsImport} from "../interface/terminals-import";
import {TerminalsBankJob} from "../interface/terminals-Bank-job";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class TerminalsBankJobService {
  public readonly jobListSubject: ReplaySubject<CountedAndPaginated<TerminalsBankJob>>
    = new ReplaySubject<CountedAndPaginated<TerminalsBankJob>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(page: number, pageSize: number, filters: object, subject?: Subject<CountedAndPaginated<TerminalsBankJob>>): void {
    this.httpClient.get(`/rest/crm/terminals-bank-job?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<TerminalsBankJob>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.jobListSubject.next(result);
        }
      });
  }

  public generate(bankId: string): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/terminals-bank-job`, {
      bank: bankId
    })
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  public deleteBankFIle(uuid: string): Observable<Uuid>  {
    return this.httpClient.delete(`/rest/crm/terminals-bank-job/${uuid}`)
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadBankFile(jobId: string): void {
    this.document.location.href = `/rest/crm/terminals-bank-job/${jobId}/downloadFile`;
  }
  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/terminals-bank-job/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
